import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { Subject } from 'rxjs';
import { filter, map, take, takeUntil } from 'rxjs/operators';
import { selectAuthUser } from '../../../store/auth/auth.selectors';
import { MbButtonComponent } from '../mb-button/mb-button.component';

@Component({
  selector: 'app-mb-drawer',
  standalone: true,
  imports: [NzDrawerModule, MbButtonComponent],
  templateUrl: './mb-drawer.component.html',
})
export class MbDrawerComponent implements OnInit, OnDestroy {
  @Input() title = '';
  @Input() icon?: string;
  @Input() isVisible = false;
  @Input() okText = 'OK';
  @Input() placement: 'left' | 'right' | 'top' | 'bottom' = 'right';
  @Input() maskOpacity = 0.7;
  @Input() okDisabled = false;
  @Input() loading = false;

  @Input() alternativeActionButtonText = '';
  @Output() isVisibleChange = new EventEmitter<boolean>();
  @Output() OkActionHandler = new EventEmitter<void>();
  @Output() CloseActionHandler = new EventEmitter<void>();
  @Output() alternativeActionHandler = new EventEmitter<void>();

  private destroy$ = new Subject<void>();

  constructor(private store: Store, private router: Router) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        if (this.isVisible) {
          this.onClose();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  showDrawer(): void {
    this.store
      .select(selectAuthUser)
      .pipe(
        take(1),
        map((user) => {
          if (!user) {
            this.router.navigate(['/auth']);
            return false;
          }

          this.isVisible = true;
          this.isVisibleChange.emit(true);
          return true;
        })
      )
      .subscribe();
  }

  onClose(): void {
    this.isVisible = false;
    this.isVisibleChange.emit(false);
    this.CloseActionHandler.emit();
  }

  onOk(): void {
    this.OkActionHandler.emit();
  }

  
}